/**
 * Palette carte / stats — tons modernes (indigo, teal, rose) sur fond clair.
 */
export const mapColors = {
  /** Vacances / visit */
  visit: '#6366F1',
  /** Travail */
  work: '#F43F5E',
  /** Études */
  studies: '#14B8A6',
  /** Semi-marathon (au moins un journey avec half-marathon: true) */
  halfMarathon: '#F59E0B',
  /** Pays sans donnée */
  empty: '#EEF2F7',
  /** Accent “total pays visités” (bloc large) */
  total: '#4338CA',
  /** Carte chronologique : pays visités cette année */
  yearHighlight: '#6366F1',
  /** Carte chronologique : autres pays */
  yearEmpty: '#E8EDF3',
  /** Contour des polygones */
  stroke: '#CBD5E1',
  /** Survol */
  strokeHover: '#64748B',
};
